import Close from '@mui/icons-material/Close'
import DeleteOutlineSharp from '@mui/icons-material/DeleteOutlineSharp'
import Download from '@mui/icons-material/Download'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { Typography } from '@mui/material'

// Image Viewer Modal Component
export default function ImageViewerModal({ open, onClose, imageId, onDelete, disabled = false }) {
  const [loading, setLoading] = useState(false)

  const handleDownload = () => {
    try {
      setLoading(true)
      const imageUrl = getImageLink(imageId)

      // Create download link
      const link = document.createElement('a')
      link.href = imageUrl
      link.download = `image_${imageId}.jpg`
      link.target = '_blank'
      link.rel = 'noopener noreferrer'

      // Try direct download first
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // toast.success('Download initiated - check your downloads folder')
      toast.info('Image opened in new tab. If not disable the popup blocker in your browser.')
    } catch (error) {
      console.error('Error downloading image:', error)
      // Fallback: Open in new tab
      try {
        window.open(getImageLink(imageId), '_blank', 'noopener,noreferrer')
        toast.info('Image opened in new tab. If not disable the popup blocker in your browser.')
      } catch (fallbackError) {
        toast.error('Unable to download image')
      }
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = () => {
    onDelete(imageId)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Image Viewer</Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}
      >
        {imageId && (
          <img
            src={getImageLink(imageId)}
            alt=""
            style={{
              maxWidth: '100%',
              maxHeight: '70vh',
              objectFit: 'contain',
              borderRadius: '8px',
            }}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ padding: '16px', gap: '8px' }}>
        <Button
          onClick={handleDownload}
          startIcon={loading ? <CircularProgress size={16} /> : <Download />}
          variant="contained"
          disabled={loading}
        >
          {loading ? 'Downloading...' : 'Download'}
        </Button>
        {!disabled && (
          <Button
            onClick={handleDelete}
            startIcon={<DeleteOutlineSharp />}
            variant="outlined"
            color="error"
          >
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
